import { BackendModel, BackendService } from "../../../core/backend.service";
import { CategoriaProducto } from "../../categoria-producto/categoria-producto.model";
import { ProductosBuscados } from "./productosBuscados.models";

export class CategoriaProductoAddMassive {

    static path:string = '/productos/';
    categorias:CategoriaProducto[];
    productos:ProductosBuscados[];

}


// WEBPACK FOOTER //
// ./src/app/productos/carga-masiva/categoria-producto-add-massive/categoria-producto-add-massive.model.ts